import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, useTheme } from '@mui/material';
import BrandLogo from './brand/BrandLogo';
import LanguageSwitcher from './brand/LanguageSwitcher';
import { useI18n } from '../i18n';
import { colors } from '../design/tokens';
import useEmbedMode from '../hooks/useEmbedMode';

/** 수취인 claim 전용 — 마케팅·풀 앱 내비 없이 최소 셸 */
export default function ClaimLayout() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useI18n();
  const embed = useEmbedMode();

  return (
    <Box sx={{ minHeight: embed ? 'auto' : '100vh', display: 'flex', flexDirection: 'column', bgcolor: colors.neutral.surface }}>
      {!embed && (
        <Box
          component="header"
          sx={{
            py: 1.25,
            px: 2,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndex.appBar,
          }}
        >
          <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <BrandLogo variant="claim" onClick={() => navigate('/')} />
            <LanguageSwitcher />
          </Container>
        </Box>
      )}
      <Box component="main" sx={{ flex: embed ? 0 : 1, py: embed ? 1 : { xs: 2, md: 3 } }}>
        <Outlet />
      </Box>
      {!embed && (
        <Box component="footer" sx={{ py: 2, px: 2, borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
          <Typography variant="caption" color="text.secondary" align="center" display="block">
            {t('footer.claim', { year: new Date().getFullYear() })}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
